import { useLocation } from 'react-router';
import { useRepubContext } from '@cx-web/feature-repub';
import { removeRepubPrefix } from '@cx-web/utils';

/**
 * The current request pathname with the repub prefix stripped (e.g. `/football`).
 *
 * Derived fresh from the router on every render, so it stays correct across SPA
 * navigations without a provider or a serialized loader field.
 */
export const useCurrentPath = () => {
  const { pathname } = useLocation();
  const { repub } = useRepubContext();

  return removeRepubPrefix(pathname, repub);
};
